<div>
  @if (attachments && attachments.length > 0) {
    <mat-label class="label-box font-weight-bold">
      {{'components.proposals.new-proposal.loaded-attachments' | translate}}
    </mat-label>
  }

  @for (attachment of attachments; track attachment; let attachIndex = $index) {
    <div class="attachment-row"
      >
      <span class="name">
        <i class="icon-pdf"></i>
        <a [href]="attachment.link" target="_blank">{{attachment.title}}</a>
      </span>
      <span class="size float-right">
        {{'generic.buttons.delete' | translate}}
        <i class="icon-cestino main-color"
        (click)="onRemoveAttachment(attachIndex)"></i>
      </span>
    </div>
  }

  <div class="col-12 links-container">
    <button mat-button type="button" color="primary" [matMenuTriggerFor]="attachmentMenu">
      <i class="icon-upload mr-2"></i>
      {{'generic.buttons.load-attach' | translate}}
    </button>
    <mat-menu #attachmentMenu="matMenu">
      @for (type of allowedAttachmentTypes; track type) {
        <button mat-menu-item (click)="onAddAttachment(type)">
          <mat-icon aria-hidden="false">file_upload</mat-icon>
          {{ type }}
        </button>
      }
    </mat-menu>
  </div>
</div>
